import {
  Button,
  Flex,
  Spacer,
  Box,
  Avatar, Image, Menu, MenuButton, MenuList, MenuItem, DarkMode, Text, Tooltip, Link, Spinner,
  useDisclosure,
  useColorModeValue,
  useBreakpointValue,
  VStack,
  Divider, 
} from "@chakra-ui/react"
import React from 'react'; // Ensure React is explicitly imported
import { /* ...existing... */ SimpleGrid } from "@chakra-ui/react";
import { /* ...existing... */ Badge } from "@chakra-ui/react";

import { ColorModeSwitcher } from "../../ColorModeSwitcher" ;
import { useNavigate } from "react-router-dom";

import eduviclogo from "../../resources/Eduvictechlogo.png";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
import {  HamburgerIcon, CloseIcon, ChevronDownIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import { CategoryNavigationDetails } from "../../Platform/Common/types";

import { useState,useCallback } from "react";

import { useEffect,useMemo } from 'react';
import axios from "axios";
import { useStudentContext } from "../Student/B2CStudentContext";
import { /* ...existing... */ FaCompass } from "react-icons/fa";

import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerCloseButton,
  IconButton,
   HStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,

} from "@chakra-ui/react";

import {
  FaChartLine,
  FaClipboardList,
  FaBookOpen,
  FaFileAlt,
  FaHistory,
  FaLifeRing,
  FaShoppingCart,
  FaUserCog,
  FaHome,
  FaGraduationCap,
  FaInfoCircle,
  FaPenNib,
  FaDownload
} from "react-icons/fa";


export const useAuthSession = () => {
  const token = localStorage.getItem("token");

  let role: string | null = null;

  if (token) {
    try {
      const decoded: any = jwtDecode(token);
      role = decoded.role_code;
    } catch {
      role = null;
    }
  }

  const isAuthenticated = !!token;

  const isStudent = role === "STUDENT";
  const isAdmin = role === "ADMIN";
  const isSupport = role === "SUPPORT";

  const isAuthenticatedStudent = isAuthenticated && isStudent;

  return {
    token,
    role,
    isAuthenticated,
    isStudent,
    isAdmin,
    isSupport,
    isAuthenticatedStudent,
  };
};

interface NavBarB2CProps {
  isAuthenticated: boolean;
  onLogout: () => void;
  userInitials: string | null;
}

const NavBarB2C: React.FC<NavBarB2CProps> = ({ isAuthenticated, onLogout, userInitials}) => {
  const navigate = useNavigate();
  const [hover, setHover] = useState(false);
 const menuListBg = useColorModeValue("blue.50", /* keep your existing dark value */ "gray.800");
  const menuBorderColor = useColorModeValue("gray.200", "gray.600");
  const menuItemHoverBg = useColorModeValue("gray.100", "gray.700");
  const categoryTextColor = useColorModeValue("blue.700", "blue.200");
  const categoryIconColor = useColorModeValue("#2B6CB0", "#63B3ED");
  const domainTextColor = useColorModeValue("gray.700", "gray.200");
  const domainIconColor = useColorModeValue("#4A5568", "#A0AEC0");
  
 
  const isMobile = useBreakpointValue({ base: true, md: false });

  const token = localStorage.getItem("b2c_token");

  const { studentContext } = useStudentContext();


  const location = useLocation();

  const isStudentAuthenticated = useMemo(() => {
  if (!isAuthenticated) return false;
  if (!token) return false;

  try {
    const decoded: any = jwtDecode(token);
    return decoded?.role_code === "STUDENT";
  } catch {
    return false;
  }
}, [isAuthenticated, token]);


  const hideLoginButton =
  location.pathname.includes("/login")

const handleLogin = () => {
  navigate(`/practice/login/`, { state: { from: location.pathname } });
};
    


//   // Function to determine dashboard route based on role
//   const getHomeRoute = () => {
//   // Not authenticated
//   if (!isAuthenticated) {
//     return `/practice/`; // Generic landing page for all users (tenant-specific or not)
//   }

//   // Authenticated but no token – corrupted session
//   if (!token) {
//     return `/practice/login/` ;
//   }

//   // Authenticated and token exists – try decoding
//   try {
//     const decoded: { role_code: string } = jwtDecode(token);

//     if (decoded.role_code in ["STUDENT", "ADMIN", "SUPPORT"])
//         {
//           console.log("Student Context", studentContext)
//          return `/practice/app/`; // Regular tenant user dashboard

//          }
//    else
//     {
//         console.warn("Unknown role_id:", decoded.role_code);
//         return `/practice/login/`; // Meaningful fallback for unsupported roles
//         }
//     }
//   catch (err) {
//     console.error("Invalid or corrupted token:", err);
//     return `/practice/login/` ;
//   }
// };

    const getHomeRoute = () => {
      if (!isAuthenticated) {
        return `/practice/`;
      }

      if (!token) {
        return `/practice/login/`;
      }

      try {
        const decoded: any = jwtDecode(token);

        switch (decoded?.role_code) {
          case "STUDENT":
          case "ADMIN":
          case "SUPPORT":
            return `/practice/app/`;

          default:
            return `/practice/login/`;
        }
      } catch {
        return `/practice/login/`;
      }
    };

   const [categoriesNavigation, setCategoriesNavigation] = useState<CategoryNavigationDetails[]>([]);
  

  const fetchCategoriesNavigation = useCallback(async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      const response = await axios.get(`${apiUrl}/b2c/public/categories-navigation`);
      setCategoriesNavigation(response.data);
    } catch (error) {
      console.error("Failed to load B2C Categories", error);
    }
  }, []);
  
  useEffect(() => {
    fetchCategoriesNavigation();
  }, [fetchCategoriesNavigation]);

   const menuItemStyles = {
    h: "30px", // Adjust to desired height
    py: 2, // Padding in the Y axis (top and bottom)
    fontWeight:"normal",
  };

  const menuHeadStyles = {
    h: "35px", // Adjust to desired height
    py: 2, // Padding in the Y axis (top and bottom)
  };

  // Columns actually needed: never more than 3, never more than the categories we have
const exploreCols = Math.min(categoriesNavigation.length, 3) || 1;

  const handleNavigation = (path: string) => {
    // For internal navigation within the same page
    if (path.startsWith('#')) {
      const element = document.getElementById(path.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
     else {
      navigate(path); 
    }
  };

    const {
  isOpen,
  onOpen,
  onClose,
} = useDisclosure();

const renderExploreTestsDrawerSection = (defaultOpen: boolean) => (
  <Accordion allowToggle defaultIndex={defaultOpen ? 0 : -1}>
    <AccordionItem border="none">

      {/* TOP-LEVEL ITEM: px={0} puts the icon on the same left edge as
          the "Eduvic Practice Platform" header text */}
      <AccordionButton px={0} py={3} borderRadius="lg">
        <HStack flex="1" spacing={3}>
          <Box as={FaCompass} boxSize="18px" flexShrink={0} />
          <Text fontSize="md" fontWeight="bold">Explore Tests</Text>
        </HStack>
        <AccordionIcon />
      </AccordionButton>

      <AccordionPanel px={0} pt={0} pb={2}>
        <VStack align="stretch" spacing={1}>
          {categoriesNavigation.map((category) => (
            <Box key={category.category_slug}>

              {/* CATEGORY: label only, same left offset as before */}
              <HStack spacing={3} align="flex-start" px={4} py={2.5}>
                <Box as={FaGraduationCap} boxSize="16px" flexShrink={0} mt="2px" />
                <Text fontSize="sm" fontWeight="bold" flex="1" minW={0}>
                  {category.category_hero_headline}
                </Text>
              </HStack>

              {/* DOMAINS */}
              <VStack align="stretch" spacing={1} mt={1} pl={6}>
                {category.domain_navigation_details.map((domain) => {
                  const comingSoon = !!domain.show_as_coming_soon;

                  return (
                    <Button
                      key={domain.domain_slug}
                      variant="ghost"
                      justifyContent="flex-start"
                      width="100%"
                      h="auto"
                      minH="32px"
                      py={2}
                      px={4}
                      borderRadius="lg"
                      whiteSpace="normal"
                      textAlign="left"
                      isDisabled={comingSoon}
                      onClick={() => {
                        navigate(`/practice/${domain.domain_slug}`);
                        onClose();
                      }}
                    >
                      <HStack spacing={3} align="flex-start" w="100%">
                        <Box as={FaBookOpen} boxSize="14px" flexShrink={0} mt="3px" />
                        <Text fontSize="sm" fontWeight="medium" flex="1" minW={0}>
                          {domain.domain_hero_headline}
                        </Text>
                        {comingSoon && (
                          <Badge colorScheme="gray" fontSize="2xs" flexShrink={0}>
                            Coming soon
                          </Badge>
                        )}
                      </HStack>
                    </Button>
                  );
                })}
              </VStack>

              <Divider my={2} />
            </Box>
          ))}
        </VStack>
      </AccordionPanel>

    </AccordionItem>
  </Accordion>
);

const renderDrawerLink = (
  icon: React.ElementType,
  label: string,
  path: string
) => (
  <Button
    variant="ghost"
    justifyContent="flex-start"
    h="auto"
    px={0}
    py={3}
    borderRadius="lg"
    onClick={() => {
      navigate(path);
      onClose();
    }}
  >
    <HStack spacing={3}>
      <Box as={icon} boxSize="18px" flexShrink={0} />
      <Text fontSize="md" fontWeight="bold">{label}</Text>
    </HStack>
  </Button>
);

return (

  <>

<Flex
  as="nav"
  bg="blue.800"
  boxShadow="2xl"
  p={2}
  align="center"
  justify="space-between"
  position="fixed"
  top="0"
  width="full"
  zIndex="sticky"
  height="70px"
>

  {/* ================= LEFT SECTION ================= */}

  <Flex
    align="center"
    gap={{ base: 1, lg: 2, xl: 3 }}
    minW={0}
    flexShrink={1}
  >

    <Image
      src={eduviclogo}
      alt="Logo"
      boxSize={{ base: "68px", lg: "74px", xl: "80px" }}
      objectFit="contain"
      cursor="pointer"
      transition="0.3s"
      onClick={() => navigate(getHomeRoute())}
      flexShrink={0}
    />

    {!isMobile && (
      <Text
        fontWeight="bold"
        color="gray.300"
        fontSize={{ base: "sm", lg: "md" }}
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
      >
        Practice Platform
      </Text>
    )}

  </Flex>


  {/* ================= CENTER NAV ================= */}

  {!isMobile && (

    <Flex
      flex="1"
      minW={0}
      justify="center"
      align="center"
      gap={{ base: 0, lg: 1, xl: 2 }}
      overflow="hidden"
      mx={{ base: 1, lg: 2, xl: 3 }}
    >

      {/* Explore Tests */}

      <Menu placement="bottom" gutter={8}>
        <DarkMode>

          <MenuButton
            as={Button}
            variant="ghost"
            color="white"
            fontSize={{ base: "sm", lg: "md" }}
            size={{ base: "md", lg: "lg" }}
            px={{ base: 2, lg: 3, xl: 4 }}
            whiteSpace="nowrap"
            _hover={{ bg: "blue.400" }}
            _focus={{ boxShadow: "none" }}
          >
            Explore Tests
            <ChevronDownIcon ml={1} />
          </MenuButton>

        </DarkMode>

          <MenuList
            maxH="75vh"
            overflowY="auto"
            minW="0"
            w={{
              base: `${Math.min(exploreCols, 2) * 310}px`,  // narrow desktop: max 2 columns
              xl: `${exploreCols * 310}px`,                  // wide desktop: up to 3
            }}
            maxW="calc(100vw - 24px)"
            p={3}
            bg={menuListBg}
            borderColor={menuBorderColor}
          >
            <SimpleGrid
              columns={{ base: Math.min(exploreCols, 2), xl: exploreCols }}
              spacing={3}
            >

            {categoriesNavigation.map((category) => (

              <Box
                key={category.category_slug}
                borderWidth="1px"
                borderColor={menuBorderColor}
                borderRadius="xl"
                p={2}
              >

                {/* CATEGORY: label only, not clickable */}
                <HStack spacing={3} align="flex-start" px={3} py={3}>
                  <Box as={FaGraduationCap} color={categoryIconColor} mt="3px" flexShrink={0} />
                  <Text fontSize="sm" fontWeight="bold" color={categoryTextColor}>
                    {category.category_hero_headline}
                  </Text>
                </HStack>

                <VStack align="stretch" spacing={1} mt={1} pl={6}>
                  {category.domain_navigation_details.map((domain) => {
                    const comingSoon = !!domain.show_as_coming_soon;

                    return (
                      <MenuItem
                        key={domain.domain_slug}
                        borderRadius="lg"
                        py={2}
                        bg="transparent"
                        isDisabled={comingSoon}
                        _hover={comingSoon ? undefined : { bg: menuItemHoverBg }}
                        onClick={() => navigate(`/practice/${domain.domain_slug}`)}
                        _focus={{ boxShadow: "none" }}
                      >
                        <HStack spacing={3} align="flex-start" w="100%">
                          <Box as={FaBookOpen} boxSize="13px" color={domainIconColor} mt="3px" flexShrink={0} />
                          <Text fontSize="sm" fontWeight="medium" color={domainTextColor} flex="1" minW={0}>
                            {domain.domain_hero_headline}
                          </Text>
                          {comingSoon && (
                            <Badge colorScheme="gray" fontSize="2xs" flexShrink={0}>
                              Coming soon
                            </Badge>
                          )}
                        </HStack>
                      </MenuItem>
                    );
                  })}
                </VStack>

              </Box>

            ))}

          </SimpleGrid>
        </MenuList>

      </Menu>


      {/* ================= LOGGED OUT ================= */}

      {!isAuthenticated && (
        <>

          <Button
            variant="ghost"
            color="white"
            fontSize={{ base: "sm", lg: "md" }}
            size={{ base: "md", lg: "lg" }}
            px={{ base: 2, lg: 3, xl: 4 }}
            whiteSpace="nowrap"
            _hover={{ bg: "blue.400" }}
            onClick={() =>
              handleNavigation("/practice/contact")
            }
          >
            Contact Us
          </Button>


          <Button
            variant="ghost"
            color="white"
            fontSize={{ base: "sm", lg: "md" }}
            size={{ base: "md", lg: "lg" }}
            px={{ base: 2, lg: 3, xl: 4 }}
            whiteSpace="nowrap"
            _hover={{ bg: "blue.400" }}
            onClick={() =>
              handleNavigation("/practice/blog")
            }
          >
            Blogs
          </Button>


          <Button
            variant="ghost"
            color="white"
            fontSize={{ base: "sm", lg: "md" }}
            size={{ base: "md", lg: "lg" }}
            px={{ base: 2, lg: 3, xl: 4 }}
            whiteSpace="nowrap"
            _hover={{ bg: "blue.400" }}
            onClick={() =>
              handleNavigation("/practice/free-resources")
            }
          >
            Free Resources
          </Button>

        </>
      )}


      {/* ================= LOGGED IN ================= */}

      {isStudentAuthenticated && (
        <>

          <Button
            variant="ghost"
            color="white"
            fontSize={{ base: "sm", lg: "md" }}
            px={{ base: 2, lg: 3, xl: 4 }}
            whiteSpace="nowrap"
            _hover={{ bg: "blue.400" }}
            onClick={() =>
              navigate("/practice/app/")
            }
          >
            Dashboard
          </Button>


          <Button
            variant="ghost"
            color="white"
            fontSize={{ base: "sm", lg: "md" }}
            px={{ base: 2, lg: 3, xl: 4 }}
            whiteSpace="nowrap"
            _hover={{ bg: "blue.400" }}
            onClick={() =>
              navigate("/practice/app/orders")
            }
          >
            Orders
          </Button>


          <Button
            variant="ghost"
            color="white"
            fontSize={{ base: "sm", lg: "md" }}
            px={{ base: 2, lg: 3, xl: 4 }}
            whiteSpace="nowrap"
            _hover={{ bg: "blue.400" }}
            onClick={() =>
              navigate("/practice/app/profile")
            }
          >
            Profile
          </Button>


          <Button
            variant="ghost"
            color="white"
            fontSize={{ base: "sm", lg: "md" }}
            px={{ base: 2, lg: 3, xl: 4 }}
            whiteSpace="nowrap"
            _hover={{ bg: "blue.400" }}
            onClick={() =>
              navigate("/practice/app/support")
            }
          >
            Support
          </Button>

        </>
      )}

    </Flex>

  )}


  {/* ================= RIGHT SECTION ================= */}

  <Flex
    align="center"
    gap={{ base: 1, lg: 2, xl: 3 }}
    flexShrink={0}
  >

    {/* MOBILE MENU */}

    {isMobile && (

      <IconButton
        aria-label="Open Menu"
        icon={<HamburgerIcon />}
        variant="ghost"
        color="white"
        _hover={{ bg: "blue.400" }}
        onClick={onOpen}
      />

    )}


    {/* LOGIN / USER */}

    {isAuthenticated ? (

      <Flex
        align="center"
        gap={{ base: 1, lg: 2, xl: 3 }}
      >

        {userInitials && (

          <Avatar
            name={userInitials}
            bg="purple.500"
            color="white"
            size={{ base: "sm", lg: "md" }}
            showBorder={false}
            getInitials={() => userInitials}
          />

        )}

        <Button
          variant="outline"
          color="white"
          _hover={{ bg: "blue.400" }}
          fontSize={{ base: "sm", lg: "md" }}
          px={{ base: 2, lg: 3 }}
          whiteSpace="nowrap"
          onClick={onLogout}
        >
          Logout
        </Button>

      </Flex>

    ) : (

      !hideLoginButton && (

        <Button
          variant="outline"
          color="white"
          _hover={{ bg: "blue.400" }}
          fontSize={{ base: "sm", lg: "md" }}
          px={{ base: 2, lg: 3 }}
          whiteSpace="nowrap"
          onClick={handleLogin}
        >
          Login
        </Button>

      )

    )}


    <ColorModeSwitcher
      justifySelf="flex-end"
      _hover={{ bg: "blue.400" }}
    />

  </Flex>

</Flex>

    {/* ================= MOBILE DRAWER ================= */}

    <Drawer
      isOpen={isOpen}
      placement="left"
      onClose={onClose}
    >

      <DrawerOverlay />

      <DrawerContent>

        <DrawerCloseButton />

          <DrawerBody pt={12}>

            {isStudentAuthenticated ? (

              <VStack align="stretch" spacing={1}>

                {/* ENTITLEMENTS */}
                <Accordion allowMultiple defaultIndex={[0]}>
                  {studentContext?.entitlements?.map((entitlement) => {
                    const practiceSet = entitlement.practice_set;
                    if (!practiceSet) return null;

                    const basePath = `/practice/app/entitlement/${entitlement.entitlement_id}/practice-set/${practiceSet.practice_set_id}`;

                    return (
                      <AccordionItem key={entitlement.entitlement_id} border="none">

                        {/* Same look as Explore Tests: icon, md bold title, px={0} */}
                        <AccordionButton px={0} py={3} borderRadius="lg">
                          <HStack flex="1" spacing={3} align="center" textAlign="left">
                            <Box as={FaBookOpen} boxSize="18px" flexShrink={0} />
                            <Box>
                              <Text fontSize="md" fontWeight="bold">
                                {practiceSet.title}
                              </Text>
                              <Text fontSize="11px" color="gray.500" fontWeight="normal">
                                {practiceSet.edition_label}
                              </Text>
                            </Box>
                          </HStack>
                          <AccordionIcon />
                        </AccordionButton>

                        <AccordionPanel px={0} pt={0} pb={2}>
                          <VStack align="stretch" spacing={1}>

                            {/* DASHBOARD */}
                            <Button
                              variant="ghost"
                              justifyContent="flex-start"
                              size="sm"
                              pl={6}
                              onClick={() => {
                                navigate(`${basePath}/dashboard`);
                                onClose();
                              }}
                            >
                              <HStack spacing={3}>
                                <FaChartLine />
                                <Text>Dashboard</Text>
                              </HStack>
                            </Button>

                            {/* PRACTICE */}
                            <Accordion allowToggle>
                              <AccordionItem border="none">
                                <AccordionButton pl={6} py={2} borderRadius="lg">
                                  <HStack flex="1" spacing={3}>
                                    <FaBookOpen />
                                    <Text fontSize="sm">Practice</Text>
                                  </HStack>
                                  <AccordionIcon />
                                </AccordionButton>

                                <AccordionPanel px={0} py={1}>
                                  <VStack align="stretch" spacing={1}>
                                    {practiceSet.sections
                                      ?.sort((a, b) => a.sequence_number - b.sequence_number)
                                      .map((section) => (
                                        <Button
                                          key={section.practice_set_section_id}
                                          variant="ghost"
                                          justifyContent="flex-start"
                                          size="sm"
                                          pl={10}
                                          onClick={() => {
                                            navigate(`${basePath}/practice/${section.practice_set_section_id}`);
                                            onClose();
                                          }}
                                        >
                                          <HStack spacing={3}>
                                            <FaClipboardList />
                                            <Text fontSize="sm">{section.title}</Text>
                                          </HStack>
                                        </Button>
                                      ))}
                                  </VStack>
                                </AccordionPanel>
                              </AccordionItem>
                            </Accordion>

                            {/* MOCK EXAMS */}
                            <Button
                              variant="ghost"
                              justifyContent="flex-start"
                              size="sm"
                              pl={6}
                              onClick={() => {
                                navigate(`${basePath}/mock-exams`);
                                onClose();
                              }}
                            >
                              <HStack spacing={3}>
                                <FaFileAlt />
                                <Text>Mock Exams</Text>
                              </HStack>
                            </Button>

                            {/* MY PROGRESS */}
                            <Button
                              variant="ghost"
                              justifyContent="flex-start"
                              size="sm"
                              pl={6}
                              onClick={() => {
                                navigate(`${basePath}/attempts`);
                                onClose();
                              }}
                            >
                              <HStack spacing={3}>
                                <FaChartLine />
                                <Text>My Progress</Text>
                              </HStack>
                            </Button>

                          </VStack>
                        </AccordionPanel>
                      </AccordionItem>
                    );
                  })}
                </Accordion>

                {/* EXPLORE TESTS */}
                {renderExploreTestsDrawerSection(false)}

                <Divider my={1} />

                {/* GLOBAL LINKS */}
                {renderDrawerLink(FaShoppingCart, "Orders & Purchases", "/practice/app/orders")}
                {renderDrawerLink(FaUserCog, "Profile & Settings", "/practice/app/profile")}
                {renderDrawerLink(FaLifeRing, "Support", "/practice/app/support")}

              </VStack>

            ) : (

              <VStack align="stretch" spacing={1}>

                {/* EXPLORE TESTS */}
                {renderExploreTestsDrawerSection(true)}

                <Divider my={1} />

                {/* GLOBAL LINKS */}
                {renderDrawerLink(FaInfoCircle, "Contact Us", "/practice/contact")}
                {renderDrawerLink(FaPenNib, "Blogs", "/practice/blog")}
                {renderDrawerLink(FaDownload, "Free Resources", "/practice/free-resources")}

              </VStack>

            )}

          </DrawerBody>

      </DrawerContent>

    </Drawer>

  </>

);

};

  export default NavBarB2C;